import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { throwError } from 'rxjs';

@Component({
  selector: 'app-unauth-backend',
  templateUrl: './unauth-backend.component.html',
  styleUrls: ['./unauth-backend.component.css']
})
export class UnauthBackendComponent implements OnInit {

  static yaMeVi: boolean = false;
  constructor(private spinner: NgxSpinnerService,) { 
    if(!UnauthBackendComponent.yaMeVi){
      UnauthBackendComponent.yaMeVi = true;
    }
    if(UnauthBackendComponent.yaMeVi){
       throwError("ya me vi")
    }
  }

  ngOnInit() {
    
  }

}
